var r=r=>"string"==typeof r,t=r=>"object"!=typeof r||r instanceof Array?void 0===r?[""]:r instanceof Array?r:[r]:[...t(r.default),...t(r.custom),...t(r.required)],e=(e,o)=>{var i=t(e),n="function"!=typeof o?r:o;return i.filter(n).join(" ").trim()};export{e as c};
//# sourceMappingURL=class-5a88b4f3.js.map
